import React, { useCallback, useRef, useState } from "react";
import localeText from "../../../../../../../locale";
import { Button } from "primereact/button";

function FileDropzone({
  accept,
  multiple,
  onSelect,
  titleKey = "uploadZoneInstruction",
  helpKey,
  formatsKey,
  buttonKey = "uploadFiles",
  maxBytes,
}) {
  const inputRef = useRef(null);
  const [dragover, setDragover] = useState(false);

  const handleFiles = useCallback(
    (fileList) => {
      if (!fileList?.length) return;
      const files = Array.from(fileList);
      const valid = maxBytes ? files.filter((file) => file.size <= maxBytes) : files;
      onSelect(multiple ? valid : valid.slice(0, 1));
      if (inputRef.current) inputRef.current.value = "";
    },
    [multiple, onSelect, maxBytes],
  );

  return (
    <div
      className={`product-form-dropzone${dragover ? " is-dragover" : ""}`}
      onDrop={(e) => {
        e.preventDefault();
        setDragover(false);
        handleFiles(e.dataTransfer?.files);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        setDragover(true);
      }}
      onDragLeave={() => setDragover(false)}
    >
      {titleKey && (
        <div>
          <svg
            width="24"
            height="21"
            viewBox="0 0 24 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5571 11.1153L16.0122 15.5694L14.5265 17.0551L12.6071 15.1358V21H10.5071V15.1336L8.58767 17.0551L7.10192 15.5694L11.5571 11.1153ZM11.5571 2.33268e-08C13.3599 8.58583e-05 15.0998 0.66267 16.4461 1.86177C17.7923 3.06088 18.651 4.71289 18.8588 6.5037C20.1652 6.85998 21.305 7.66406 22.0788 8.7754C22.8525 9.88675 23.2112 11.2347 23.092 12.5836C22.9728 13.9325 22.3833 15.1967 21.4266 16.1551C20.4699 17.1135 19.2068 17.7053 17.8581 17.8269V15.7122C18.3413 15.6432 18.8059 15.4786 19.2248 15.2281C19.6437 14.9776 20.0085 14.6462 20.2979 14.2531C20.5873 13.8601 20.7955 13.4134 20.9103 12.939C21.0252 12.4646 21.0444 11.9721 20.9669 11.4902C20.8893 11.0083 20.7166 10.5467 20.4587 10.1323C20.2008 9.71795 19.8629 9.35909 19.4648 9.07669C19.0667 8.7943 18.6164 8.59403 18.1401 8.48758C17.6637 8.38113 17.171 8.37063 16.6905 8.4567C16.855 7.69113 16.8461 6.89847 16.6645 6.13678C16.4829 5.37509 16.1333 4.66366 15.6411 4.05461C15.149 3.44555 14.5269 2.95429 13.8203 2.6168C13.1137 2.27932 12.3406 2.10417 11.5576 2.10417C10.7746 2.10417 10.0014 2.27932 9.29487 2.6168C8.5883 2.95429 7.96617 3.44555 7.47404 4.05461C6.98191 4.66366 6.63226 5.37509 6.45069 6.13678C6.26912 6.89847 6.26023 7.69113 6.42467 8.4567C5.4667 8.2768 4.47651 8.48482 3.67193 9.035C2.86734 9.58518 2.31426 10.4324 2.13437 11.3904C1.95447 12.3484 2.16249 13.3386 2.71267 14.1431C3.26284 14.9477 4.11011 15.5008 5.06807 15.6807L5.25707 15.7122V17.8269C3.90829 17.7054 2.64509 17.1138 1.68826 16.1555C0.731421 15.1972 0.14181 13.933 0.0224744 12.5841C-0.0968612 11.2351 0.26167 9.8871 1.0354 8.77566C1.80914 7.66423 2.94886 6.86006 4.25537 6.5037C4.46296 4.7128 5.32154 3.06066 6.66783 1.86151C8.01411 0.662361 9.75417 -0.000143538 11.5571 2.33268e-08V2.33268e-08Z"
              fill="var(--theme-secondary)"
            />
          </svg>
        </div>
      )}
      <div className={`product-form-toggle-title${helpKey ? "text-regular font-medium mt-3" : ""}`}>
        {localeText(titleKey)}
      </div>
      {helpKey ? (
        <div className="product-form-dropzone-help text-xs">{localeText(helpKey)}</div>
      ) : null}
      {formatsKey ? <p className="product-form-help">{localeText(formatsKey)}</p> : null}
      <Button
        className="mt-3 product-form-dropzone-button border-round-lg flex align-items-center gap-2 m-auto text-sm font-medium"
        onClick={() => inputRef.current?.click()}
      >
        <svg
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.750338 4.5H14.1198C14.2236 4.49995 14.3263 4.52144 14.4213 4.5631C14.5163 4.60476 14.6017 4.66569 14.672 4.74203C14.7422 4.81837 14.7959 4.90847 14.8296 5.00662C14.8633 5.10477 14.8762 5.20884 14.8676 5.31225L14.2421 12.8123C14.2265 12.9997 14.141 13.1744 14.0027 13.3018C13.8643 13.4291 13.6832 13.4999 13.4951 13.5H1.37509C1.18702 13.4999 1.00586 13.4291 0.867504 13.3018C0.729148 13.1744 0.643697 12.9997 0.628088 12.8123L0.00258791 5.31225C-0.00602471 5.20884 0.0069146 5.10477 0.0405875 5.00662C0.0742604 4.90847 0.127934 4.81837 0.198214 4.74203C0.268494 4.66569 0.353852 4.60476 0.448888 4.5631C0.543924 4.52144 0.646571 4.49995 0.750338 4.5V4.5ZM2.06509 12H12.8051L13.3046 6H1.56559L2.06509 12V12ZM8.49559 1.5H13.4351C13.634 1.5 13.8248 1.57902 13.9654 1.71967C14.1061 1.86032 14.1851 2.05109 14.1851 2.25V3H0.685088V0.75C0.685088 0.551088 0.764105 0.360322 0.904758 0.21967C1.04541 0.0790176 1.23618 0 1.43509 0H6.99559L8.49559 1.5Z"
            fill="var(--theme-text-muted)"
          />
        </svg>
        {localeText(buttonKey)}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        hidden
        onChange={(e) => handleFiles(e.target.files)}
      />
    </div>
  );
}

export default FileDropzone;
